export function computeBMI(height, weight, decimal = 2) {
    const heightNumber = Number(height);
    const weightNumber = Number(weight);
    if (isNaN(heightNumber) || isNaN(weightNumber) || heightNumber == 0 || weightNumber == 0) {
        return "";
    } else {
        const rawBMI = weightNumber / Math.pow(heightNumber / 100, 2);
        const bmi = rawBMI.toFixed(decimal);
        return `${bmi}`;
    }
}

export function computeSex(gender) {
    switch (gender) {
        case "男":
            return 1
        case "女":
            return 2
        default:
            return 0
    }
}

export function countDown({
    remainSeconds: remainSeconds,
    trigger: trigger,
    over: over
}) {
    let timer = setInterval(() => {
        remainSeconds--;
        trigger(remainSeconds);
        if (remainSeconds == 0) {
            clearInterval(timer);
            over();
        }
    }, 1000);
}

/**
 * 向下取值并格式化为指定小数位数
 * @param {number|string} value - 原始数值
 * @param {number} decimals - 小数位数，默认为2
 * @returns {string} 格式化后的字符串，无效值返回'-'
 */
export function formatNumberFloor(value, decimals = 2) {
    if (value === null || value === undefined || value === '') {
        return '-';
    }
    
    const numValue = Number(value);
    if (isNaN(numValue)) {
        return '-';
    }
    
    // 向下取值到指定小数位：先乘以10^decimals，向下取整，再除以10^decimals
    const multiplier = Math.pow(10, decimals);
    const flooredValue = Math.floor(numValue * multiplier) / multiplier;
    return flooredValue.toFixed(decimals);
}
